import { css, keyframes } from 'styled-components';
import colors from './colors/brandColors';

export const pxToRem = (px: number, base: number) => `${px / base}rem`;

export const fontSize = (size: number, base = 16) => css`
  font-size: ${size}px; // older browsers fallback
  font-size: ${pxToRem(size, base)};
`;

export const wh = (w: number, h: number = w) => css`
  width: ${w}px;
  height: ${h}px;
`;

export const centerFlex = css`
  justify-content: center;
  align-items: center;
`;
interface BaseShadowProps {
  color: string;
}

export const baseShadow = ({ color }: BaseShadowProps) => css`
  box-shadow: 0 10px 6px -6px ${color || '#777'};
`;

interface FontProps {
  color: string;
  size: number;
  family: string;
}

//TODO: add font-weight
export const font = ({ color, size, family }: FontProps) => css`
  color: ${color || 'red'};
  ${fontSize(size)};
  font-family: ${family || 'Poppins'};
`;

export const hexToRgba = (hexColor: string, alpha: number): string => {
  const [r, g, b] = hexColor.match(/\w\w/g)!.map((x) => parseInt(x, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getColor = (color = 'purple', weight = 700, alpha = 1): string => {
  const colorHex: string = (
    colors as { [key: string]: { [key: number]: string } }
  )[color][weight];

  if (alpha === 1) {
    return colorHex;
  }
  return hexToRgba(colorHex, alpha);
};

export const mediaQueryMobile = '@media (max-width: 767px)';

export const anvilkf = keyframes`
  0% {
    transform: scale(1) translateY(0px);
    opacity: 0;
    box-shadow: 0 0 0 rgba(241, 241, 241, 0);
  }
  1% {
    transform: scale(0.96) translateY(10px);
    opacity: 0;
    box-shadow: 0 0 0 rgba(241, 241, 241, 0);
  }
  100% {
    transform: scale(1) translateY(0px);
    opacity: 1;
    box-shadow: 0 0 500px rgba(241, 241, 241, 0);
  }
`;
